import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
  name: "authenticationSlice",
  initialState: {
    loginData: "",
    token: localStorage.getItem("token"),
    nav: localStorage.getItem("nav"),
    loggedIn: localStorage.getItem("loggedIn"),
    pwdUpdateFlag: localStorage.getItem("pwdUpdateFlag"),
    userTypeId: localStorage.getItem("userTypeId"),
    companyId: localStorage.getItem("companyId"),
    companyLogo: localStorage.getItem("companyLogo"),
    companyName: localStorage.getItem("companyName"),
  },
  reducers: {
    LOGIN_SUCCESS: (state, action) => {
      return {
        ...state,
        loginData: action.payload,
        token: localStorage.getItem("token"),
        nav: localStorage.getItem("nav"),
        loggedIn: localStorage.getItem("loggedIn"),
        pwdUpdateFlag: localStorage.getItem("pwdUpdateFlag"),
        userTypeId: localStorage.getItem("userTypeId"),
        companyId: localStorage.getItem("companyId"),
        companyLogo: localStorage.getItem("companyLogo"),
        companyName: localStorage.getItem("companyName"),
      };
    },
    LOGIN_ERROR: (state) => {
      return {
        ...state,
        loginData: "",
        token: "",
        nav: "",
        loggedIn: "",
        pwdUpdateFlag: "",
        userTypeId: "",
        companyId: "",
        companyLogo: "",
        companyName: "",
      };
    },
  },
});

export const { LOGIN_SUCCESS, LOGIN_ERROR } = slice.actions;
export default slice.reducer;
